import { useEffect, useState } from 'react';
import { formatSecondsToTimer, getTimeDifferenceInSeconds } from './utils';

const ZERO_TIMER_COUNT = '00:00:00';

/**
 * Hook that calculates the remaining time until a bid expiry date.
 *
 * @param {string} [bidExpiryDateTime] - The bid expiry date and time in UTC, ISO 8601 format (e.g., "2024-08-20T09:56:59.287Z").
 *
 */
export const useBidExpiryTimer = (bidExpiryDateTime: string) => {
  const [bidExpiry, setBidExpiry] = useState(ZERO_TIMER_COUNT);

  const isBidExpired = bidExpiry === ZERO_TIMER_COUNT;

  useEffect(() => {
    let timerInterval: NodeJS.Timeout | null = null;

    if (bidExpiryDateTime) {
      timerInterval = setInterval(() => {
        const timeDifference = getTimeDifferenceInSeconds(bidExpiryDateTime);

        if (timeDifference > 0) {
          const timerValue = formatSecondsToTimer(timeDifference);
          setBidExpiry(timerValue);
        } else {
          if (timerInterval) {
            clearInterval(timerInterval);
          }
          setBidExpiry(ZERO_TIMER_COUNT);
        }
      }, 1000);
    }

    return () => {
      if (timerInterval) {
        clearInterval(timerInterval);
      }
    };
  }, [bidExpiryDateTime]);

  return { bidExpiry, isBidExpired };
};
